module.exports = __webpack_public_path__ + "static/media/analysis_icon.98a3837c.svg";